export const exchangeInitialValues = {
  exchangable: "",
  specification: "",
  restrictionsAndDetails: "",
  value: "",
  dueDate: new Date().toISOString().slice(0, 10),
};
